import http from "./public";

var tenant = "/api/admin/tenant/";
export const roleMenus = (params) => {
  //获取角色菜单
  return http(`${tenant}roleMenus`, params);
};
export const createCompanyAdminRoleMenu = (params) => {
  //设置企业主角色菜单
  return http(`${tenant}createCompanyAdminRoleMenu`, params);
};
export const tenantPage = (params) => {
  //获取角色菜单
  return http(`${tenant}page`, params);
};
export const userRolePage = (params) => {
  //用户角色查询分页
  return http(`${tenant}userRolePage`, params);
};
export const userDelRole = (params) => {
  //用户删除角色
  return http(`${tenant}userDelRole`, params);
};
export const userAddRole = (params) => {
  //用户添加角色
  return http(`${tenant}userAddRole`, params);
};
//
// /api/admin/tenant/page

export const menuPage = (params) => {
  //获取角色菜单
  return http(`/api/admin/sys/menuPage`, params);
};
export const menus = (params) => {
  //获取角色菜单
  return http(`/api/admin/sys/menus`, params);
};
// /api/admin/tenant/

export const createManagerV2 = (params) => {
  //获取角色菜单
  return http(`${tenant}createManagerV2`, params);
};
//
export const tenantCompanyInfo = (params) => {
  //公司详情
  return http(`${tenant}companyInfo`, params);
};

const help = "/api/admin/help/";

/**
 * @description 新增保险公司巡查闭环配置信息
 */
export const addHelpInsureClosedConfig = (params) => {
  //公司详情
  return http(`${help}addHelpInsureClosedConfig`, params);
};
/**
 * @description 修改保险公司巡查闭环配置信息
 */
export const editHelpInsureClosedConfig = (params) => {
  //公司详情
  return http(`${help}editHelpInsureClosedConfig`, params);
};
/**
 * @description 查询保险公司巡查闭环配置信息
 */
export const queryHelpInsureClosedConfigInfo = (params) => {
  //公司详情
  return http(`${help}queryHelpInsureClosedConfigInfo`, params);
};
/**
 * @description 查询保险公司费用分页列表
 */
export const queryAdminSmsInsureFeePage = (params) => {
  //公司详情
  return http(`/api/admin/sms/queryAdminSmsInsureFeePage`, params);
};
/**
 * @description 发送短信
 */
export const adminSmsInsureFeeSendInfo = (params) => {
  //公司详情
  return http(`/api/admin/sms/adminSmsInsureFeeSendInfo`, params);
};
